export default __webpack_public_path__ + "static/media/icon_performance-reports.85746def.svg";